import styled from "styled-components";

export const Container = styled.div`
position: relative;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    margin-bottom: 16px;
  }
`;
